import { render, staticRenderFns } from "./wy-custom-cell-sample.vue?vue&type=template&id=ed4b18aa&"
import script from "./wy-custom-cell-sample.vue?vue&type=script&lang=js&"
export * from "./wy-custom-cell-sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports